<script setup>
/**
 * Se trata de un label con el icono del tipo de usuario y el nombre de usuario que
 * cuando hacen click muestra el popup con la información del usuario, sus
 * hijos etc.
 */
import * as utilsUsuarios from '@/libs/usuarios';
import { computed } from 'vue';
import IconosTipoUsuario from './IconosTipoUsuario.vue';
import PopoverCifra from '../cifra/PopoverCifra.vue';
import PopoverUsuario from './PopoverUsuario.vue';

const props = defineProps({
  usuario: { type: Object, required: true },
  badge: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const clasesLabel = computed(() => (
  props.badge ? 'label label-default' : ''
));
</script>

<template>
  <PopoverCifra
    class="popover-wrapper"
    :class="{ clickable: !disabled }"
    :delay="{ show: 0, hide: 100 }"
    :disabled="disabled"
  >
    <span :class="clasesLabel">
      <slot name="label">
        <IconosTipoUsuario :usuario="usuario"></IconosTipoUsuario>
        {{ utilsUsuarios.fullname(usuario) }}
      </slot>
      <slot name="append"></slot>
    </span>
    <template #contenido>
      <PopoverUsuario v-if="!disabled" :usuario="usuario"></PopoverUsuario>
    </template>
  </PopoverCifra>
</template>
